export class ErrorScriptLoader extends Error {}
